import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import { PaginatedRequest } from '@wajeez-web/core/api';

export interface getAllContentEntityTextProps extends PaginatedRequest {
  ContentEntityId?: string;
}
export const getAllContentEntityText: ApiMethod<
  getAllContentEntityTextProps,
  Server.ContentEntityTextOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ContentEntityTexts_Client(
      undefined,
      contentClient
    );
    const response = await client.contentEntityTexts_get_V1(
      undefined,
      data.ContentEntityId,
      undefined,
      data.page,
      data.pageSize
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const addText: ApiMethod<
  Server.AddContentEntityTextInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ContentEntityTexts_Client(
      undefined,
      contentClient
    );
    const response = await client.contentEntityTexts_addText_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const removeText: ApiMethod<
  Server.RemoveContentEntityText,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ContentEntityTexts_Client(
      undefined,
      contentClient
    );
    const response = await client.contentEntityTexts_removeText_post_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const setDefaultText: ApiMethod<
  Server.SetContentEntityTextAsDefault,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ContentEntityTexts_Client(
      undefined,
      contentClient
    );
    const response = await client.contentEntityTexts_setDefaultText_post_V1(
      data
    );
    if (response.success) {
      return;
    }
    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const updateText: ApiMethod<
  Server.EditContentEntityTextInput,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ContentEntityTexts_Client(
      undefined,
      contentClient
    );
    const response = await client.contentEntityTexts_updateText_put_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
